import { useCallback, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import CreditCard01Icon from "@untitled-ui/icons-react/build/esm/CreditCard01";
import Settings04Icon from "@untitled-ui/icons-react/build/esm/Settings04";
import User01Icon from "@untitled-ui/icons-react/build/esm/User03";
import {
  Avatar,
  Box,
  Button,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Stack,
  SvgIcon,
  Typography,
  Snackbar,
  Paper,
  Chip,
  Link,
} from "@mui/material";
import { RouterLink } from "src/components/router-link";
import { useAuth } from "src/hooks/use-auth";
import { useMockedUser } from "src/hooks/use-mocked-user";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { Issuer } from "src/utils/auth";
import {
  API_SERVICE_BACKEND_2,
  API_AUTH_SERVICE_BACKEND,
  API_SERVICE_BACKEND,
} from "src/config";
import axios from "axios";
import {
  clearLocalStorage,
  clearSessionStorage,
  getSessionStorage,
} from "src/utils/storage";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import LogOut01Icon from "@untitled-ui/icons-react/build/esm/LogOut01";
import Settings01 from "@untitled-ui/icons-react/build/esm/Settings01";
import Tooltip from '@mui/material/Tooltip';
import { Business, HelpCenterOutlined } from "@mui/icons-material";
import SessionChangeDialog from "src/components/SessionChangeDialog";
import Cookies from "js-cookie";
import { useUserDetail } from "src/hooks/react-query/useAuth";
import authAxios from "src/lib/axios";
import { useImagePreview } from "src/hooks/use-image-preview";

export const AccountPopover = (props) => {
  const userDetail = useUserDetail();
  const { customEmailConfigDomain, setDefaultValues, supportCenterURL } = useContext(
    WhiteLabelConfigurationContext
  );
  const { anchorEl, onClose, open, ...other } = props;
  const router = useRouter();
  const auth = useAuth();
  // const [popoverOpen, setPopoverOpen] = useState(false);
  // const [anchor, setAnchorEl] = useState(null);
  const [userData, setUserData] = useState([]);
  const [userDat, setUserDat] = useState(undefined);
  const [copied, setCopied] = useState(false);
  const [sessionDialogOpen, setSessionDialogOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const sessionPhotoUrl = getSessionStorage("photoUrl");
  const sessionAvatarPreview = useImagePreview(sessionPhotoUrl || null, {
    axiosInstance: authAxios,
    fallbackToRawOnError: true,
  });
  const user = {
    name: getSessionStorage("fullName"),
    email: getSessionStorage("userEmail"),
    ownerEmail: getSessionStorage("ownerEmail") || null,
    avatar: sessionAvatarPreview || sessionPhotoUrl || undefined,
  };
  const isSearchflag = JSON.parse(sessionStorage.getItem("changeFlags") || "{}")?.search;

  const checkSessionChanges = (action) => {
    const spintaxGuard = JSON.parse(sessionStorage.getItem("spintaxGuard") || "null");
    if (spintaxGuard?.active && spintaxGuard?.coverage < 95) {
      const targetPath = action === 'settings' ? paths.dashboard.account : null;
      window.dispatchEvent(new CustomEvent("spintaxNavigationBlocked", { detail: { path: targetPath } }));
      return false;
    }

    const flags = JSON.parse(sessionStorage.getItem("changeFlags") || "{}");
    const hasChanges = Object.values(flags).some(Boolean);

    if (hasChanges) {
      if (typeof action === 'object' && action.type) {
        setPendingAction(action);
      } else {
        setPendingAction(action);
      }
      setSessionDialogOpen(true);
      return false;
    }
    return true;
  };

  const executeAction = (action) => {
    if (typeof action === 'object' && action.type) {
      action = action.type;
    }

    switch (action) {
      case 'settings':
        setPopoverOpen(false);
        onClose();
        handleClose();
        router.push(paths.dashboard.account);
        break;
      case 'logout':
        handleLogoutAction();
        break;
      case 'workspace':
        if (pendingAction && pendingAction.workspaceData) {
          executeWorkspaceSwitch(pendingAction.workspaceData);
        }
        break;
      default:
        break;
    }
  };

  const handleLogoutAction = useCallback(async () => {
    const isNewInterfaceEnabled = localStorage.getItem("isNewInterfaceEnabled");
    setDefaultValues();
    clearLocalStorage();
    clearSessionStorage();
    if (window.Intercom) {
      window.Intercom("shutdown");
      window.intercomSettings = {};
    }
    try {

      // await axios.post(`${API_AUTH_SERVICE_BACKEND}/logout`, {}, { withCredentials: true });
      onClose?.();
      clearLocalStorage();
      Cookies.remove("b2b_at", { path: '/' })
      switch (auth.issuer) {
        case Issuer.Amplify: {
          await auth.signOut();
          break;
        }
        case Issuer.Auth0: {
          await auth.logout();
          break;
        }

        case Issuer.Firebase: {
          await auth.signOut();

          break;
        }
        case Issuer.JWT: {
          await auth.signOut();
          break;
        }

        default: {
          console.warn("Using an unknown Auth Issuer, did not log out");
        }
      }

      router.push(paths.index);
    } catch (err) {
      await auth.signOut();
      router.push(paths.index);
      console.error(err);
    }
    if (window.Intercom) {
      window.Intercom("boot", {
        app_id: "qaecvjwi",
      });
    }
    localStorage.setItem("isNewInterfaceEnabled", isNewInterfaceEnabled);
  }, [auth, router, onClose]);

  const handleLogout = useCallback(async () => {
    if (checkSessionChanges('logout')) {
      handleLogoutAction();
    }
  }, [handleLogoutAction]);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchor, setAnchorEl] = useState(null);
  const [orgId, setOrgId] = useState("");
  const handleAccount = (event) => {
    setPopoverOpen(true);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setPopoverOpen(false);
  };
  const id = popoverOpen ? "popover-button" : undefined;

  // const handleClick = (event) => {
  //   event.preventDefault();
  //   setPopoverOpen(true);
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setPopoverOpen(false);
  // };
  // const id = popoverOpen ? 'popover-button' : undefined;

  const getUserInfo = async (email) => {
    try {
      const res = await axios.get(
        `${API_SERVICE_BACKEND}/getuserdetail?email=${encodeURIComponent(email)}`
      );
      if (!res.data.status) return;

      setUserData(res.data.data.organizationList);
      setOrgId(res.data.data.organization_id);
      return res.data.data;
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (user?.email) {
      getUserInfo(user.email);
    }
  }, [user.email]);

  const generateJWTToken = async (email, invitationTo) => {
    let payload = {
      email: email,
      teamMemberEmail: email,
      userEmail: invitationTo,
    };
    try {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_2}/getJWTAuthToken`,
        {
          payload,
        }
      );

      return res.data.token;
    } catch (err) {
      //console.log(err);
      toast.error("Failed to generate authentication token", {
        position: "top-center",
        autoClose: 4000,
        pauseOnHover: true,
      });
      return null;
    }
  };

  const getUserDetails = async (email, orgId) => {
    try {
      // const response = await fetch1(
      //   `${API_SERVICE_BACKEND}/getusercampagindetails/${email}/${orgId}`
      // );
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getusercampagindetails/${email}/${orgId}`
      );
      const data = response.data;

      if (data.data === "No Data Found") {
        //console.log(data.data);
      }
    } catch (err) {
      //console.log(err);
    }
  };

  const handleManageUser = async (email, organization_id, invitationTo) => {
    const workspaceData = { inviteBy: email, orgId: organization_id, invitationTo };

    if (checkSessionChanges('workspace')) {
      await executeWorkspaceSwitch(workspaceData);
    } else {
      setPendingAction({ type: 'workspace', workspaceData });
    }
  };

  const executeWorkspaceSwitch = async (workspaceData) => {
    try {
      await getUserDetails(workspaceData.inviteBy, workspaceData.orgId);
      const token = await generateJWTToken(workspaceData.inviteBy, workspaceData.invitationTo);

      if (!token) {
        toast.error("Account is disabled — contact administrator", {
          position: "top-center",
          autoClose: 4000,
          pauseOnHover: true,
        });
        return;
      }

      // Get user info to determine proper redirect path
      const userInfo = await getUserInfo(workspaceData.inviteBy);
      
      let targetPath = paths.dashboard.crm.peopleSearch;
const isVIPUser = userInfo?.isVIPUser;
      if (!userInfo?.signature && !isVIPUser) {
        targetPath = `/signaturePage/${encodeURIComponent(userInfo?.email)}`;
      } else {
        // Redirect to people search page for all authenticated users
        targetPath = paths.dashboard.crm.peopleSearch;
      }

      // Close the popover before redirecting
      setPopoverOpen(false);
      onClose();

      window.open(`${window.location.origin}${targetPath}?token=${token}`, "_self");
    } catch (err) {
      console.error("Error opening workspace:", err);
      toast.error("Account is disabled — contact administrator", {
        position: "top-center",
        autoClose: 4000,
        pauseOnHover: true,
      });
    }
  };
  function handleAuxClick(event) {
    if (event.button === 1) {
      event.preventDefault(); // Prevent the default behavior of opening links in new tabs
    } else if (event.metaKey) {
      event.preventDefault(); // Prevent the default behavior if Command key is pressed
    } else {
      onClose();
    }
  }
  const getUserDetailsMember = useCallback(async () => {
    // When in member workspace, userEmail = workspace owner; use ownerEmail for the actual person's workspaces
    const emailForWorkspaceList = user.ownerEmail || user.email;
    if (!emailForWorkspaceList) return;

    try {
      // Fetch both the user's own workspace and invited workspaces (use actual person's email, not workspace owner)
      const [invitedRes, ownWorkspaceRes] = await Promise.all([
        axios.get(`${API_SERVICE_BACKEND}/list-inviteTo/${encodeURIComponent(emailForWorkspaceList)}`),
        axios.get(`${API_SERVICE_BACKEND}/getuserdetail?email=${encodeURIComponent(emailForWorkspaceList)}`),
      ]);
      
      const invitedWorkspaces = invitedRes.data?.data || [];
      const ownWorkspaceData = ownWorkspaceRes.data?.data;

      // Create workspace list
      let workspaceList = [...invitedWorkspaces];
      
      // Add user's own workspace to the list if it exists (enables switching between own + invited workspaces)
      if (ownWorkspaceData && ownWorkspaceData.organization_id) {
        const ownWorkspace = {
          inviteBy: ownWorkspaceData.email,
          invitationTo: ownWorkspaceData.email,
          organizationId: ownWorkspaceData.organization_id,
          inviteByCompanyName: ownWorkspaceData.companyName || "My Workspace",
          status: "accept",
          isOwnWorkspace: true,
        };
        workspaceList.unshift(ownWorkspace);
      }
      
      setUserDat(workspaceList);
    } catch (err) {
      console.error("Error loading workspace data:", err);
      toast.error("Failed to load workspace information");
      setUserDat([]);
    }
  }, [user.email, user.ownerEmail]);

  useEffect(() => {
    getUserDetailsMember();
  }, [getUserDetailsMember]);

  const firstName = user.name?.split(" ")?.[0];
  const lastName = user.name?.split(" ")?.[1];

  const handleCopy = (event) => {
    const email = user.ownerEmail || user.email;
    navigator.clipboard.writeText(email).then(() => {
      setAnchorEl(event.currentTarget);
      setCopied(true);
      // Auto-hide after 1.5s
      setTimeout(() => {
        setCopied(false);
        setAnchorEl(null);
      }, 1500);
    });
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
      disableScrollLock
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 250 } }}
      {...other}
    >
      {/* <Box sx={{ p: 2 }}>
        <Typography variant="body1">{user.name}</Typography>
        <Typography color="text.secondary" variant="body2">
          {user?.ownerEmail ? user?.ownerEmail : user.email}
        </Typography>
      </Box>
      <Divider /> */}
      <Stack alignItems="center" direction="row" spacing={2} sx={{ p: 2 }}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: "divider",
            height: 40,
            width: 40,
            borderRadius: "50%",
          }}
        >
          <Avatar
            sx={{
              height: 32,
              width: 32,
            }}
            src={user.avatar}
          >
            <SvgIcon>
              <User01Icon />
            </SvgIcon>
          </Avatar>
        </Box>
        <Box>
          <Typography
            variant="body1"
            //color="text.primary"
            sx={{
              fontWeight: 700,
              color: "var(--nav-item-color)",
              fontSize: "18px",
              width: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {firstName || ""} {lastName === "undefined" ? "" : lastName || ""}
          </Typography>

          <Tooltip title={user.email || user.ownerEmail} arrow>
            <span>
              <Typography
                variant="body2"
                sx={{
                  color: "var(--nav-item-color)",
                  fontSize: "16px",
                  // width: "200px",
                  maxWidth: "170px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                  position: "relative",
                  display: "block",
                  whiteSpace: "nowrap"
                }}
                onClick={handleCopy}
              >
                {user.email || user.ownerEmail}
              </Typography>
            </span>
          </Tooltip>
          <Popover
            open={copied}
            anchorEl={anchorEl}
            onClose={() => {
              setCopied(false);
              setAnchorEl(null);
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            disableRestoreFocus
            PaperProps={{
              sx: { padding: "4px 8px", backgroundColor: "#333", color: "#fff", fontSize: "12px" },
            }}
          >
            Copied!
          </Popover>

        </Box>
      </Stack>
      <Divider />
      <Box sx={{ p: 1 }}>
        <ListItemButton
          onClick={handleAccount}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon
              fontSize="small"
              sx={{ color: (theme) => theme.palette.text.primary }}
            >
              <SwitchAccountIcon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1">Switch Workspace</Typography>
            }
          />
        </ListItemButton>
      </Box>
      <Popover
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        disableScrollLock
        // PaperProps={{ sx: { width: 300 } }}
        id={id}
        open={popoverOpen}
        anchorEl={anchor}
        onClose={handleClose}
      >
        <Box sx={{ p: 2, minWidth: 300 }}>
          {userDat === undefined ? (
            // Loading state
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                Loading workspaces...
              </Typography>
            </Box>
          ) : userDat && Array.isArray(userDat) && userDat.length ? (
            userDat.map((data, index) => {
              // user.email = current workspace owner when in member workspace
              const isCurrentWorkspace = data.inviteBy === user.email;
              return (
              <Paper
                key={index}
                elevation={2}
                sx={{
                  p: 2,
                  mb: index < userDat.length - 1 ? 2 : 0,
                  borderRadius: 2,
                  cursor: "pointer",
                  transition: "0.2s ease",
                  border: isCurrentWorkspace ? "2px solid" : "none",
                  borderColor: isCurrentWorkspace ? "primary.main" : "transparent",
                }}
                onClick={() =>
                  handleManageUser(data.inviteBy, data.organizationId || orgId, data.invitationTo)
                }
              >
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {data.inviteByCompanyName || "Unknown Workspace"}
                    </Typography>
                    {data.isOwnWorkspace && !isCurrentWorkspace && (
                      <Chip
                        label="Main"
                        color="primary"
                        size="small"
                        variant="outlined"
                        sx={{ height: 20, fontSize: "0.7rem" }}
                      />
                    )}
                    {isCurrentWorkspace && (
                      <Chip
                        label="Current"
                        color="primary"
                        size="small"
                        sx={{ height: 20, fontSize: "0.7rem" }}
                      />
                    )}
                  </Box>

                  <Typography variant="body2" color="text.secondary" mt={0.5}>
                    Workspace Email: {data.inviteBy}
                  </Typography>

                  <Chip
                    label={data.status === "accept" ? "Accepted" : "Pending"}
                    color={data.status === "accept" ? "success" : "warning"}
                    size="small"
                    sx={{ mt: 1 }}
                  />
                </Box>
              </Paper>
            );})
          ) : (
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                No additional workspaces available
              </Typography>
              <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
                You can continue using your current workspace
              </Typography>
            </Box>
          )}
        </Box>
      </Popover>

      {/* <Box sx={{ p: 2 }}> */}
      {/* <Typography >User List</Typography> */}
      {/* <Typography color="text.secondary">widgiwdgw</Typography> */}
      {/* {userData?.map((email)=> (
                <Box>
                  <Button color="text.secondary"
                  //  onClick={handleManageUser}
                   >
                    {email}
                    </Button>
                </Box>
              ))} */}
      {/* </Box> */}
      {/* <Box sx={{ p: 1 }}>
        <ListItemButton
          component={RouterLink}
          href={paths.dashboard.account}
          // onClick={onClose}
          onClick={handleAuxClick}
          onAuxClick={handleAuxClick}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <Settings04Icon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body1">Settings</Typography>}
          />
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href={paths.dashboard.index}
          onClick={onClose}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <CreditCard01Icon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={(
              <Typography variant="body1">
                Billing
              </Typography>
            )}
          />
        </ListItemButton>
      </Box> */}
      {/* <Divider sx={{ my: "0 !important" }} /> */}
      <Box
        sx={{
          display: "flex",
          p: 1,
          justifyContent: "center",
        }}
      >
        {/* <Button color="inherit" onClick={handleLogout} size="small">
          Log out
        </Button> */}
        <ListItemButton
          onClick={() => {
            if (checkSessionChanges('settings')) {
              executeAction('settings');
            }
          }}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon
              fontSize="small"
              sx={{ color: (theme) => theme.palette.text.primary }}
            >
              <Settings01 />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body1">Settings</Typography>}
          />
        </ListItemButton>
      </Box>
      {/*<Box
        sx={{
          display: "flex",
          p: 1,
          justifyContent: "flex-start",
        }}
      >
        <Link
          href={supportCenterURL || "https://help.b2brocket.ai/"}
          target="_blank"
          rel="noopener noreferrer"
          sx={{width: "100%", color: theme => theme.palette.text.primary, textDecoration: "none !important"}}
        >    
          <ListItemButton
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5,
            }}
          >
            <ListItemIcon>
              <SvgIcon
                fontSize="small"
                sx={{ color: (theme) => theme.palette.text.primary }}
              >
                <HelpCenterOutlined />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body1">Help Center</Typography>}
            />
          </ListItemButton>
        </Link>
      </Box>*/}
      <Divider />
      <Box
        sx={{
          display: "flex",
          p: 1,
          justifyContent: "center",
        }}
      >
        {/* <Button color="inherit" onClick={handleLogout} size="small">
          Log out
        </Button> */}
        <ListItemButton
          onClick={handleLogout}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon
              fontSize="small"
              sx={{ color: (theme) => theme.palette.text.primary }}
            >
              <LogOut01Icon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body1">Log Out</Typography>}
          />
        </ListItemButton>
      </Box>

      <SessionChangeDialog
        open={sessionDialogOpen}
        onClose={() => setSessionDialogOpen(false)}
        onConfirm={() => {
          setSessionDialogOpen(false);
          executeAction(pendingAction);
          setPendingAction(null);
        }}
        title={`Unsaved ${ isSearchflag ? "Filters" : "Changes"}`}
        message={`You have unsaved ${ isSearchflag ? "filters" : "changes"}. Are you sure you want to continue?`}
      />
    </Popover>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
